// src/mobile/search.ts
import { setupEventListenersIfNeeded } from './event-manager';
import { postJsMessage } from '../../../bridge';
import API from '../../../api';
import { isAvailable } from 'jssdk/utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.cancelSearch
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.5.0
 * android    6.5.0
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function cancelSearch(): Promise<
  NativeAPIResponseMessage<unknown>
> {
  await isAvailable('mobile.cancelSearch');
  setupEventListenersIfNeeded();
  return postJsMessage(API.cancelSearch, {});
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.activeSearch
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.5.0
 * android    6.5.0
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function activeSearch(search: {
  text: string;
}): Promise<NativeAPIResponseMessage<unknown>> {
  await isAvailable('mobile.activeSearch');
  setupEventListenersIfNeeded();
  return postJsMessage(API.activeSearch, search);
}
